import { MarketCountryCode } from "@backmarket/http-api/src/api-models/MarketCountryCode";
import { LOCALES } from "@backmarket/http-api/src/standards/Locale";
import { MARKETS } from "../../config.js";
export function getMarkets(enableEsUsContent) {
  const markets = { ...MARKETS };
  if (enableEsUsContent) {
    markets[MarketCountryCode.US] = {
      ...markets[MarketCountryCode.US],
      locales: [...markets[MarketCountryCode.US].locales, LOCALES.es_US]
    };
  }
  return markets;
}
